import React from 'react';
import { useInstantSearch } from 'react-instantsearch';

export const CustomClearRefinements = ({ exclusions = {} }) => {
    const { uiState } = useInstantSearch();
    const indexUiState = Object.values(uiState)[0] || {};
    const hasRefinements =
        (indexUiState.refinementList &&
            Object.keys(indexUiState.refinementList).some(
                (key) => indexUiState.refinementList[key]?.length > 0
            )) ||
        (indexUiState.range &&
            Object.keys(indexUiState.range).some((key) => {
                const r = indexUiState.range[key];
                // ✅ range est une string "min:max", "min:" ou ":max"
                if (typeof r === 'string') {
                    const [min, max] = r.split(':');
                    return min !== '' || max !== '';
                }
                // fallback objet
                return r && (Number.isFinite(r.min) || Number.isFinite(r.max));
            })) ||
        Object.keys(exclusions).length > 0;

    const clearRefinements = () => {
        const searchParams = window.location.href.split('?')[0];
        window.location.href = searchParams;
    };

    return (
        <button
            id="customClear_btn"
            onClick={clearRefinements}
            disabled={!hasRefinements}
            className={`custom-clear-btn ${!hasRefinements ? 'custom-clear-btn--disabled' : ''}`}
        >
            <svg width="14" height="14" viewBox="0 0 20 20" fill="none"
                 stroke="currentColor" strokeWidth="2.2">
                <path d="M4 4l12 12M16 4L4 16"/>
            </svg>
            Réinitialiser les filtres
        </button>
    );
};